import { useContext } from 'react';
import { UserContext } from '@services/Session';
import axios from '@helpers/axios';

interface UserInfo {
  nameFirst: string;
  nameLast: string;
  phoneNumber?: string;
  email?: string;
  inviteCode?: string;
  tosAccepted?: boolean;
}

const useAccountInfo = () => {
  const userStore = useContext(UserContext);

  const validateUserInfo = async ({
    nameFirst,
    nameLast,
    phoneNumber,
    email,
    inviteCode,
    tosAccepted,
  }: UserInfo) => {
    const newUser = {
      nameFirst,
      nameLast,
    } as {
      nameFirst: string;
      nameLast: string;
      phoneList?: string[];
      email?: string;
      tosAcccepted?: boolean;
    };

    if (phoneNumber) {
      newUser['phoneList'] = [phoneNumber];
    }
    if (email) {
      newUser['email'] = email.trim().toLowerCase();
    }

    let body;
    if (inviteCode) {
      body = { newUser, inviteCode, tsTosAccept: tosAccepted };
    } else {
      body = { newUser, tsTosAccept: tosAccepted };
    }

    const userId = userStore.authUser?.claims?.shd_user_id;
    if (!userId) {
      throw new Error('User ID is not available');
    }

    const user = userStore.user;
    userStore.setUser({ ...user, ...newUser });

    return axios.put(`/api/user/${userId}`, body);
  };

  return {
    validateUserInfo,
  };
};

export default useAccountInfo;
